import React, { useState } from "react";
import { AdminDashboardFiltersPanel } from "kh-design-system/components";
import Filter from "../../../assets/img/Filter.svg";
import { dashboardColors } from "../../../themes/Theme";
import { Icon } from '@iconify/react';

const FilterFromKHStyles = ({
    filtersConfig,
    selectedFilters,
    onChange,
    onClear,
    onApply,
    cancelClickHandler,
    disableApplyBtn,
    onClickCustomBtn,
    view,
    filterNoCloseRef,
    activeFilterId
}) => {
    const [dropActive, setDropActive] = useState(false); // To open and close filter drop down
    return (
        <div className="d-flex flex-column align-items-center justify-content-center">
            <AdminDashboardFiltersPanel
                filtersConfig={filtersConfig}
                selectedFilters={selectedFilters}
                onChange={onChange}
                onClear={onClear}
                onApply={onApply}
                cancelClickHandler={cancelClickHandler}
                setToggleFilter={setDropActive}
                disableApplyBtn={disableApplyBtn}
                onClickCustomBtn={onClickCustomBtn}
                filterNoCloseRef={filterNoCloseRef}
                activeFilterId={activeFilterId}
            >
                {view === "mobile" ? (
                    <div
                        className="filter_icon d-flex justify-content-center align-items-center"
                        onClick={() => setDropActive(!dropActive)}
                    >
                        <img src={Filter} alt="Filter" />
                    </div>
                ) : (
                    <div className="d-flex position-relative">
                        <button
                            className="fltBtn"
                            onClick={() => setDropActive(!dropActive)}
                        >
                            <Icon
                                icon="iconamoon:funnel-light"
                                height="22px"
                                width="22px"
                                style={{
                                    marginRight: "10px",
                                    color: dashboardColors.light.primary,
                                }}
                            />
                            Filter
                            <i
                                className={
                                    dropActive ? "fas fa-chevron-down" : "fas fa-chevron-up"
                                }
                                style={{ marginLeft: "20px" }}
                            ></i>
                        </button>
                    </div>
                )}
            </AdminDashboardFiltersPanel>
            <style>
                {
                    `
                    .filters-body{
                        margin-bottom: 0px;
                    }
                    .filter-option{
                        color: rgb(33, 37, 41);
                        font-size: 14px;
                        gap: 0px;
                    }
                    .filters-panel{
                        z-index: 100;
                        margin-top: 8px;
                    }
                    .filter-search{
                        padding: 6px;
                    }
                    .fltBtn {
                        border: 1px solid #cdd4db;
                        border-radius: 2px;
                        background: transparent;
                        padding: 5px 10px;
                        white-space: nowrap;
                    }
                    .filter_icon {
						width: 36px;
						height: 36px;
						border-radius: 2px;
						border: 1px solid #CDD4DB;
					}
                    .btn-wrap{
                        width: 70%!important;
                    }
                    `
                }
            </style>
        </div>
    )
}

export default FilterFromKHStyles;